import makeStyles from 'e100-react-components/lib/styles/makeStyles';

export const useStyles = makeStyles(({
  spacing,
  palette,
  typography,
  zIndex
}) => ({
  inputRoot: {
    padding: `${spacing(0.4)}px ${spacing()}px !important`
  },
  input: {
    fontSize: `${typography.body2.fontSize} !important`,
    marginLeft: spacing(0.5)
  },
  focused: {
    '& > div': {
      borderColor: palette.primary.main,
      backgroundColor: 'transparent'
    }
  },
  popupIndicator: {
    display: 'none'
  },
  clearIndicator: {
    visibility: 'visible'
  },
  paper: {
    marginTop: spacing()
  },
  popper: {
    zIndex: zIndex.snackbar
  },
  cardDescription: {
    marginTop: spacing()
  }
}));
